export class Authorize {
  username!: string;
  email!: string;
  roles!: string[];
  token!: string;
  tenantId!: string;
}
